// extracted by mini-css-extract-plugin
export default {"toolBar":"VendorsToolBar_toolBar__Oj3iY","title":"VendorsToolBar_title__ZuXa5","toolBarButtons":"VendorsToolBar_toolBarButtons__o6gCd","button":"VendorsToolBar_button__-fKJU"};